import { render, staticRenderFns } from "./LmCheckbox.vue?vue&type=template&id=72b004f8&scoped=true&"
import script from "./LmCheckbox.vue?vue&type=script&lang=js&"
export * from "./LmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LmCheckbox.vue?vue&type=style&index=0&id=72b004f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b004f8",
  null
  
)

export default component.exports